import { api } from "@/lib/api";

const VISITOR_KEY = "ihmj_visitor_id";

export function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (crypto?.randomUUID?.() || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function detectSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = (params.get("utm_source") || params.get("ref") || "").toLowerCase();
    if (utm) {
      if (utm.includes("tiktok")) return "tiktok";
      if (utm.includes("facebook") || utm === "fb") return "facebook";
      return "other";
    }
    const ref = (document.referrer || "").toLowerCase();
    if (!ref) return "direct";
    if (ref.includes("tiktok")) return "tiktok";
    if (ref.includes("facebook") || ref.includes("fb.")) return "facebook";
    // Treat our own domain as direct (internal navigation)
    if (ref.includes(window.location.hostname)) return "direct";
    return "other";
  } catch {
    return "direct";
  }
}

export async function trackVisit() {
  try {
    await api.post("/track/visit", { visitor_id: getVisitorId(), source: detectSource() });
  } catch { /* analytics must never block the page */ }
}

export async function trackConversion() {
  try {
    await api.post("/track/convert", { visitor_id: getVisitorId() });
  } catch { /* non-critical */ }
}

export async function trackQuiz(event, step) {
  try {
    await api.post("/track/quiz", { visitor_id: getVisitorId(), event, step });
  } catch { /* analytics must never block the page */ }
}
